import React, { useEffect, useState } from 'react';
import { Input, Radio, Select, Form, DatePicker, Menu, Dropdown } from 'antd';
import TextArea from "antd/lib/input/TextArea";
import styles from "./scss/neweventcenter.module.scss";
import { URCheckBox } from '../../../shared/widgets/checkbox';
import IcloudImg from "../../../styles/images/event/icloud.svg";
import GoogleCalcImg from "../../../styles/images/event/google_calendar.svg";
import OutlookImg from "../../../styles/images/event/outlook.svg";
import { initialStateModel } from '../../../models/model';
import { useSelector } from 'react-redux';
import { URButton } from '../../../shared/widgets/button';
import moment from 'moment';
import { saveEventCreation } from '../../../base/eventService/eventApiService';
import { URAvatarGroup } from '../../../shared/widgets/avatarGroup';
import { URStatusDot } from '../../../shared/widgets/avatarGroup/statusDot';
import { userStatusColor } from '../../../base/callService/common';
import taskimg2 from "../../../styles/images/task2.svg";

type eventState = {
  isRecurringEvent: boolean;
  recurrence: string;
  eventName: string;
  startDate: Date;
  time: any;
  hours: number;
  minutes: number;
  participants: any;
  calendarType: number;
  description: string;
  allDay: boolean;
  isOpen: boolean;
  contacts: Array<any>;
  tempfilteredContacts: Array<any>;
  assigneeError: boolean;
  nameError: boolean;
  startDateError: boolean;
}
type ResetLinkProps = {
  handleCancel: (state: boolean) => void;
}
export default function NewEventRightCenter({ handleCancel }: ResetLinkProps) {

  const allReducer: initialStateModel = useSelector((state: initialStateModel) => state);
  const workContacts = allReducer.contactReducer.workContacts;
  let timeRes = moment(new Date()).format('HH:mm')
  const [eventInfo, setEventInfo] = useState<eventState>
    ({
      isRecurringEvent: false, recurrence: "", eventName: "", startDate: new Date(), time: timeRes, hours: 1, minutes: 0,
      participants: [], calendarType: 0, description: "", allDay: false, isOpen: false, contacts: workContacts, assigneeError: false,
      tempfilteredContacts: workContacts, nameError: false, startDateError: false
    });

  useEffect(() => {
    setEventInfo({ ...eventInfo, isRecurringEvent:false,recurrence:"",eventName:"",
      startDate:new Date(),time:timeRes,hours:1,minutes:0,
      participants:[],calendarType:0,description:"",allDay:false,isOpen:false});
  }, [eventInfo.isOpen]);

  const nameInputChange = (name: string, e: any) => {
    
    setEventInfo({ ...eventInfo, nameError: false, [name]: e.target.value });
  };
  const handleAlldayCheck = (e: any) => {
    setEventInfo({ ...eventInfo, allDay: e.target.checked });
  };
  const handleChange = (value: any) => {
    let error = value.length < 1 ? true : false;
    setEventInfo({ ...eventInfo, assigneeError: error, participants: value });
  };
  const radioChecked = (e: any) => {
    setEventInfo({ ...eventInfo, calendarType: e.target.value });
  };
  const disabledDate = (from: any, current: any) => {
    return new Date(from.setDate(from.getDate() - 1)) >= current;
  };
  const handleDateChange = (value: any) => {
    setEventInfo({ ...eventInfo, startDateError: false, startDate: value });
  };
  const selectHoursDropdown = (value: any) => {
    setEventInfo({ ...eventInfo, hours: value.key });
  };
  const selectMinsDropdown = (value: any) => {
    setEventInfo({ ...eventInfo, minutes: value.key });
  };
  const handleTimeChange = (value: any) => {
    setEventInfo({ ...eventInfo, time: value.key });
  };
  const onSubmit = async () => {
    let formData: any = eventInfo;
    if (eventInfo.eventName.trim() === "" && !eventInfo.startDate && eventInfo.participants.length < 1) {
      setEventInfo({ ...eventInfo, assigneeError: true, nameError: true, startDateError: true });
    } else if (!eventInfo.startDate && eventInfo.participants.length < 1) {
      setEventInfo({ ...eventInfo, assigneeError: true, startDateError: true });
    } else if (eventInfo.eventName.trim() === "" && !eventInfo.startDate) {
      setEventInfo({ ...eventInfo, nameError: true, startDateError: true });
    } else if (eventInfo.eventName.trim() === "" && eventInfo.participants.length < 1) {
      setEventInfo({ ...eventInfo, assigneeError: true, nameError: true });
    }
    else if (eventInfo.eventName.trim() === "") {
      setEventInfo({ ...eventInfo, nameError: true });
    } else if (!eventInfo.startDate) {
      setEventInfo({ ...eventInfo, startDateError: true });
    }
    else if (eventInfo.participants.length < 1) {
      setEventInfo({ ...eventInfo, assigneeError: true });
    }
    else {
      saveEventCreation(formData, 'loginuser');
      setEventInfo({ ...eventInfo, assigneeError: false, nameError: false, startDateError: false, participants: [],
        eventName: "",description: "",calendarType: 0 });
      handleCancel(false);
    }
  };
  const cancelWindow = () => {
    handleCancel(false);
    setEventInfo({
      ...eventInfo, isRecurringEvent: false, recurrence: "", eventName: "",
      startDate: new Date(), time: timeRes, hours: 1, minutes: 0, assigneeError: false, nameError: false, startDateError: false,
      participants: [], calendarType: 0, description: "", allDay: false, isOpen: false
    });
  };
  const searchInput = (e: string) => {
    let searchText = e.toLowerCase();
    const filterParticipant: Array<any> = workContacts
      .filter((value: any) => value?.caller_id?.toLowerCase().includes(searchText));
    setEventInfo({ ...eventInfo, contacts: filterParticipant });
  };
  let allday: any = Array.from(Array(24).keys());
  const hours = (
    <Menu onClick={selectHoursDropdown} className="scroller eventHoursmodal">
      {allday.map((list: any) => <Menu.Item key={list}>{list} hr</Menu.Item>)}
    </Menu>
  );
  const minuts = (
    <Menu onClick={selectMinsDropdown} className="scroller eventMinutesmodal">
      <Menu.Item key={15}>15 min</Menu.Item>
      <Menu.Item key={30}>30 min</Menu.Item>
      <Menu.Item key={45}>45 min</Menu.Item>
      <Menu.Item key={0}>00 min</Menu.Item>
    </Menu>
  );
 
  let timeDurationList: any = Array.from(Array(24).keys());
  const startTime = (
    <Menu className={`${"scroller"} ${styles.timeSelect}`} onClick={handleTimeChange}>
      {timeDurationList.map((value: string, index: number) => {
        return (
          <>{index === 0 ?
            <>
              <Menu.Item
                key={`${index}:00`}>{`00:00`}</Menu.Item>
              <Menu.Item
                key={`${index}:30`}>{`00:30`}</Menu.Item>
            </>
            :
            <>
              <Menu.Item
                key={`${value.toString().length === 1 ? '0' + value : value}:00`}>{`${value.toString().length === 1 ? '0' + value : value}:00`}</Menu.Item>
              <Menu.Item key={`${value.toString().length === 1 ? '0' + value : value}:30`}
              >{`${value.toString().length === 1 ? '0' + value : value}:30`}</Menu.Item>

            </>
          }
          </>
        );
      })
      }
    </Menu>
  );
 
    let sTime = eventInfo.time;
    let endMinutes = eventInfo.minutes === 0 ? "00" : eventInfo.minutes;
    let endHours = eventInfo.hours.toString().length === 1 ? `0${eventInfo.hours}`:eventInfo.hours;
    let startDateTime = moment(eventInfo.startDate).format('YYYY/MM/DD') + ' ' + sTime;
    let endDateTime = new Date(startDateTime); 
    endDateTime.setHours(endDateTime.getHours() + parseInt(endHours.toString()));
    endDateTime.setMinutes(endDateTime.getMinutes() + parseInt(endMinutes.toString()));
    let EndTime = moment(endDateTime).format('hh:mm A');
  let EndDate = moment(endDateTime).format('ll');
  
    let len = Math.ceil((eventInfo?.contacts?.length / 8));
    let random_color = Array(len).fill([1, 2, 3, 4, 5, 6, 7, 8]).flat();
  return (
    <>
      <div className={styles.modalcustomheadertop}>
        <span className={`icon_close ${styles.cursorTop}`} onClick={cancelWindow} />
        <h2>New Event </h2>
      </div>
      <div className={`eventpopup2 ${styles.neweventpopupscreen}`}>
        <div className={styles.half}>
          <label className={styles.eventLabel}> Event Name</label>
          <div className={`${styles.selectopt} ${styles.marBtmminset}`}>
            <Input placeholder="Event Title" maxLength={40} className={eventInfo.nameError ? `inputerror ${styles.inputarea}` : styles.inputarea}
              onChange={(e) => nameInputChange('eventName', e)} value={eventInfo.eventName}
            ></Input>
            {eventInfo?.nameError && <p className="error">This event needs a name</p>}
          </div>
          {/* <div className={styles.selectopt}>
            <div className={styles.meetingRecordTitle}></div>
            <URCheckBox onChange={handleAlldayCheck} /> <span className={styles.allDaytxt}>All Day</span>
          </div> */}

          <div className={styles.timedate}>
            <div className={styles.leftdate}>
              <div className={`timefield2 ${styles.date}`}>
                <label className={styles.eventLabel}>Event Start</label>
                <DatePicker className={eventInfo?.startDateError ? `inputerror customDatepicker` : "customDatepicker"} format={'DD/MM/YYYY'}
                  disabledDate={(e) => disabledDate(new Date(), e)}
                  defaultValue={moment(eventInfo.startDate)}
                  dropdownClassName='datepickerDropdown' placeholder='Start date' onChange={handleDateChange} />
                {eventInfo?.startDateError && <p className="error">Select a start date </p>}
              </div>
            </div>
            <div className={styles.rightdropdown}>
              <div className={`startclock ${styles.startclock}`}>
                <label>Time</label>
                {/* <TimePicker defaultValue={moment(eventInfo.time, 'h:mm a')} format={'h:mm a'}
                  onChange={handleTimeChange}/> */}
                <Dropdown overlay={startTime} trigger={['click']} placement="bottomCenter">
                  <h3 className={styles.rightalign}>
                    {eventInfo.time}
                    <span className={`${"icon_down-arrow"} ${"menudroprotate"}`}></span></h3></Dropdown>

              </div>
              <div className={`timefield2  ${styles.dropdownsec}`}>
                <label>Duration</label>
                <Dropdown overlay={hours} trigger={['click']} placement="bottomCenter">
                  <h3 className={styles.rightalign}>{eventInfo.hours} hr
                    <span className={`${"icon_down-arrow"} ${"menudroprotate"}`}></span></h3></Dropdown>
                <Dropdown overlay={minuts} trigger={['click']} placement="bottomCenter"><h3>{eventInfo.minutes} min
                  <span className={`${"icon_down-arrow"} ${"menudroprotate"}`}></span></h3></Dropdown>
              </div>
            </div>
          </div>
          <p className={styles.righttxt}>This event will end on {EndDate} at {EndTime}</p>
          <div className={styles.selectopt}>
            <div className={styles.formGrouprow}>
              <div className={styles.meetingRecordTitle}>Add Participants</div>
              <div className={styles.shareSelect}>
                <div className={styles.insideicon}>
                  <img src={taskimg2} alt="" className={styles.withImage}/>
                  <Select
                    mode="multiple"
                    style={{ width: '100%' }}
                    placeholder="No Participants"
                    onChange={handleChange}
                    dropdownClassName="newChatSel"
                    filterOption={false}
                    showSearch={true}
                    onSearch={(e: string) => searchInput(e)}
                    className={eventInfo?.assigneeError ? "inputerror newselects taskcreations" : "newselects taskcreations"}
                    value={eventInfo.participants}>
                    {eventInfo.contacts?.map((contact: any, index: any) => {
                         
                      let name = contact?.caller_id ? contact?.caller_id : contact?.team_name;
                      return (

                        <option key={index}
                          value={contact.sip_login_id ? contact.sip_login_id : `con${contact.team_id}`}>
                          <div className="dropdowndesign">
                            <div className="usergroupss">
                              <URAvatarGroup className={`lefts size20 colorBG${random_color[index]}`} profileInfo={<>
                                {contact.ImageURL || contact.profile_image_url ?
                                  <img src={contact.ImageURL ? contact.ImageURL : contact.profile_image_url} alt="" /> :
                                  <span>{name?.charAt(0).toUpperCase()}</span>}
                                <URStatusDot
                                  className={userStatusColor(contact?.user_status, 'small')} />
                              </>} />
                              
                            </div>
                            <div className="names">{name && name}</div>
                            {!contact.team_id && <div className="ext">{contact?.ext}</div>}
                          </div>
                        </option>

                      );
                    })}
                  </Select>
                </div>
              </div>

              {eventInfo?.assigneeError && <p className="error">Invite someone</p>}
            </div>
          </div>
          {/* <div className="radiobuttonsec" className={styles.selectopt}> */}
          <div className="radiobuttonsec">
            <div className={styles.meetingRecordTitle}>Add to calender</div>
            <Form.Item>
              <Radio.Group onChange={(e) => radioChecked(e)}>
                <Radio value={'icloud'}><span className="radiotxt"><img src={IcloudImg} alt={IcloudImg} />
                  iCloud</span></Radio>
                <Radio value={'google'}><span className="radiotxt"><img src={GoogleCalcImg} alt={GoogleCalcImg} />
                  Google Calendar</span></Radio>
                <Radio value={'outlook'}><span className="radiotxt"><img src={OutlookImg} alt={OutlookImg} />
                  Outlook</span></Radio>
              </Radio.Group>
            </Form.Item>
          </div>
          <div className={`${styles.selectopt} ${styles.marbtmmin}`}>
            <div className={styles.meetingRecordTitle}>Description</div>
            <TextArea rows={4} onChange={(e: any) => nameInputChange('description', e)}
              value={eventInfo.description} name="description" placeholder='Write a event description'
              className="notesArea" />
          </div>
        </div>
      </div>
      <div className={`${styles.footersection} ${"footersection"}`}>
        <URButton className="urButton buttonWhite" name="Cancel" onClick={cancelWindow}></URButton>
        <URButton className="urButton buttonBlue marlftmin" name="Save" onClick={onSubmit}></URButton>
      </div>
    </>
  );
};
